module.exports = __webpack_public_path__ + "img/undraw3.a18a3c01.jpg";